package app.nestbridge.app.monitoring

actual fun initializeSentry(environment: String) {
    val dsn = sentryDsn
    if (dsn.isBlank()) return

    val nativeJSON: dynamic = js("JSON")
    val sentry: dynamic = js("require('@sentry/browser')")
    // HIPAA: sendDefaultPii=false. Request-body scrubbing on web is best handled by a
    // browser-level beforeSend / HTML init (a function can't be passed via JSON config).
    sentry.init(nativeJSON.parse("""{"dsn":"$dsn","environment":"$environment","autoSessionTracking":true,"debug":$sentryDebug,"tracesSampleRate":$sentryTracesSampleRate,"sendDefaultPii":false}"""))
}
